(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var KlantenVertellen = /** @class */ (function () {
    function KlantenVertellen(hash) {
        this.url = "https://www.klantenvertellen.nl/v1/review/feed.xml?hash=" + hash;
        // Run immediately
        this.loadFeed();
    }
    KlantenVertellen.prototype.loadFeed = function () {
        $.ajax({
            url: this.url,
            dataType: "xml",
            success: this.handleSuccess.bind(this),
            error: this.handleError.bind(this)
        });
    };
    KlantenVertellen.prototype.handleSuccess = function (xml) {
        var avg = $(xml).find("last12MonthAverageRating").text();
        var count = $(xml).find("numberReviews").text();
        $(".js-kv-average").text(avg);
        $(".js-kv-reviews").text(count);
    };
    KlantenVertellen.prototype.handleError = function () {
        console.error("Failed to load Klantenvertellen feed.");
    };
    return KlantenVertellen;
}());
var kv = new KlantenVertellen("zxode2lwmtbylyj");
},{}],2:[function(require,module,exports){
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Anchors = /** @class */ (function () {
    function Anchors() {
        var _this = this;
        this.items = [];
        this.nav = $('nav');
        this.parse = function () {
            $('a[data-anchor]').each(function (index, item) {
                var anchor;
                var anchorItem = $(item);
                if (!anchorItem.data('anchor')) {
                    var anchor_1 = new Anchor(anchorItem);
                    anchorItem.data('anchor', anchor_1);
                    _this.items.push(anchor_1);
                }
            });
            _this.hashchange(event);
        };
        this.hashchange = function (event) {
            var hash = window.location.hash.replace('#', '');
            _this.hash = hash;
            if (_this.hash != hash || !event) {
                if (hash) {
                    for (var i = 0; i < _this.items.length; i++) {
                        var item = _this.items[i];
                        console.log(item);
                        if (item.id == hash) {
                            $(item.element.addClass('is-active'));
                            $('body, html').stop(true).animate({ 'scrollTop': item.target.offset().top - _this.nav.outerHeight() });
                        }
                        else {
                            $(item.element.removeClass('is-active'));
                        }
                    }
                }
            }
        };
        this.parse();
        $(window).on('hashchange', this.hashchange.bind(this));
    }
    return Anchors;
}());
var Anchor = /** @class */ (function (_super) {
    __extends(Anchor, _super);
    function Anchor(element) {
        var _this = _super.call(this) || this;
        _this.click = function (event) {
            if (_this.id == window.location.hash.replace('#', '')) {
                console.log(Anchors);
            }
        };
        _this.element = element;
        console.log(element);
        if (!_this.element.length)
            return _this;
        _this.element.on('click', _this.click.bind(_this));
        _this.id = _this.element.attr('href').split('#').pop();
        _this.target = $('#' + _this.id);
        _this.target.attr('id', 'js-' + _this.id);
        return _this;
    }
    return Anchor;
}(Anchors));
var anchors = new Anchors();
},{}],3:[function(require,module,exports){
var Faq = /** @class */ (function () {
    function Faq() {
        this.element = $('.js-faq');
        $('article').hide();
        $('article').first().show();
        $('.js-faq--topic').first().addClass('active');
        $('.js-accessibility').hide();
        this.topics = this.element.find('.js-faq--topics a');
        this.items = this.element.find('.js-item');
        var openItems;
        var openTopics;
        this.items.each(function (index, item) {
            var items = $(item);
            var openItems = new FaqItems(items);
        });
        this.topics.each(function (index, item) {
            var topic = $(item);
            var openTopics = new FaqTopics(topic);
        });
        $('#' + $('.js-faq--topic.active').attr('aria-controls')).find('.js-item').first().addClass('active');
    }
    return Faq;
}());
var FaqTopics = /** @class */ (function () {
    function FaqTopics(topic) {
        this.element = topic;
        this.element.on('click', this.open.bind(this));
    }
    // hideArticles() {
    //     $('article').removeClass('show');
    // }
    // deslectAllTabs() {
    //     $('js-faq--topics a').attr('aria-selected', false);
    // }
    FaqTopics.prototype.open = function (event) {
        event.preventDefault();
        var tab = '#' + this.element.attr('aria-controls');
        $('article').hide();
        $(tab).show();
        if (this.element.hasClass('active')) {
            this.element.removeClass('active');
        }
        else {
            $('.js-faq--topic.active').removeClass('active');
            this.element.addClass('active');
        }
    };
    return FaqTopics;
}());
var FaqItems = /** @class */ (function () {
    function FaqItems(items) {
        this.element = items;
        this.content = this.element.find('dd');
        this.element.on('mouseup', this.toggle.bind(this));
        this.element.removeClass('active');
    }
    FaqItems.prototype.toggle = function () {
        if (this.element.hasClass('active')) {
            this.element.removeClass('active');
        }
        else {
            $('.js-item.active').removeClass('active');
            this.element.addClass('active');
        }
    };
    FaqItems.prototype.close = function () {
    };
    return FaqItems;
}());
var faq = new Faq();
},{}],4:[function(require,module,exports){
var Lightbox = /** @class */ (function () {
    function Lightbox() {
        var _this = this;
        this.element = $('.js-lightbox');
        this.items = this.element.find('.js-item');
        this.items.each(function (index, item) {
            new LightboxItems($(item), _this.items);
        });
    }
    return Lightbox;
}());
var LightboxItems = /** @class */ (function () {
    function LightboxItems(item, allItems) {
        var _this = this;
        this.lightbox = $('.c-lightbox');
        this.element = item;
        this.allItems = allItems;
        this.currentIndex = this.element.index();
        if (!this.lightbox.length)
            return;
        this.element.find('.js-lightbox__inner').on('click', function (e) { return _this.open(e); });
    }
    LightboxItems.prototype.getTemplate = function (src, type, alt) {
        // Added a loader div and a hidden state for the image initially
        if (type === 'video') {
            return "\n                <div class='u-video c-lightbox__video'>\n                    <iframe width='560' height='315' src='" + src + "' frameborder='0' allow='autoplay; encrypted-media' allowfullscreen></iframe>\n                    <button class='c-lightbox__close c-btn mt-0 c-btn--no-icon c-btn--square'>\n                        <span class=\"material-symbols-outlined\">close</span>\n                    </button>\n                </div>";
        }
        return "\n            <div class='c-lightbox__imgwrapper'>\n                <div class='c-lightbox__loader'></div>\n                <img unselectable=\"on\" class='c-lightbox__image' src='" + src + "' style='display: none;' />\n                <button class='c-lightbox__close is-inline-block c-btn c-btn--primary p-1 mt-0' style=\"border-radius: 100% !important; display: inline-block !important; width: auto !important;\">\n                    <span class=\"material-symbols-outlined\">close</span>\n                </button>\n\n            </div>\n            <div class=\"columns is-justify-content-space-between\">\n            <div class=\"column is-1\">\n            <button class='c-btn c-lightbox__prev c-btn--primary mt-0'>\n                <span class=\"material-symbols-outlined\">navigate_before</span>\n            </button>\n            </div>\n            <div class=\"column has-text-centered is-8\">\n            <figcaption>" + alt + "</figcaption>\n            </div>\n            <div class=\"column is-1\">\n            <button class='c-btn c-lightbox__next c-btn--primary mt-0'>\n                <span class=\"material-symbols-outlined\">navigate_next</span>\n            </button>\n            </div>\n            </div>";
    };
    LightboxItems.prototype.open = function (event) {
        event.preventDefault();
        this.currentIndex = this.element.index();
        this.render();
        this.lightbox.addClass('u-is-visible');
    };
    LightboxItems.prototype.render = function () {
        var container = this.lightbox.find('.c-lightbox__inner');
        container.empty();
        var currentTarget = this.allItems.eq(this.currentIndex);
        var src = currentTarget.find('.js-lightbox__inner').attr('href') || '';
        var type = currentTarget.attr('data-type') || 'image';
        var alt = currentTarget.find('.js-lightbox__inner').find("img").attr('alt') || '';
        container.append(this.getTemplate(src, type, alt));
        this.setupControls();
    };
    LightboxItems.prototype.setupControls = function () {
        var _this = this;
        var nextBtn = this.lightbox.find('.c-lightbox__next');
        var prevBtn = this.lightbox.find('.c-lightbox__prev');
        var closeBtn = this.lightbox.find('.c-lightbox__close');
        var image = this.lightbox.find('.c-lightbox__image');
        var loader = this.lightbox.find('.c-lightbox__loader');
        var total = this.allItems.length;
        // Loading Logic: Show image and hide loader only when file is ready
        image.on('load', function () {
            loader.hide();
            image.fadeIn(200);
        });
        // Navigation visibility
        prevBtn.toggle(this.currentIndex > 0);
        nextBtn.toggle(this.currentIndex < total - 1);
        // Event cleaning
        closeBtn.off('click').on('click', function () { return _this.close(); });
        nextBtn.off('click').on('click', function () { return _this.navigate(1); });
        prevBtn.off('click').on('click', function () { return _this.navigate(-1); });
        image.off('click').on('click', function () {
            if (_this.currentIndex < total - 1)
                _this.navigate(1);
        });
    };
    LightboxItems.prototype.navigate = function (direction) {
        var newIndex = this.currentIndex + direction;
        if (newIndex >= 0 && newIndex < this.allItems.length) {
            this.currentIndex = newIndex;
            this.render();
        }
    };
    LightboxItems.prototype.close = function () {
        this.lightbox.removeClass('u-is-visible');
        this.lightbox.find('.c-lightbox__inner').empty();
    };
    return LightboxItems;
}());
new Lightbox();
},{}],5:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoadMore = /** @class */ (function () {
    function LoadMore() {
        this.element = $('.js-LoadMore');
        var loadMoreElements;
        this.element.each(function (index, item) {
            var items = $(item);
            var loadMoreElements = new LoadMoreElements(items);
        });
    }
    return LoadMore;
}());
var LoadMoreElements = /** @class */ (function () {
    function LoadMoreElements(items) {
        this.element = items;
        this.items = this.element.find('.js-item');
        this.text = this.element.attr('data-text');
        if (this.items.length > 9) {
            this.element.append("\n                <div class=\"column is-12 u-block u-center\">\n                    <button class=\"c-btn c-btn--no-icon c-btn--more js-btn\" >\n                        <span>" + this.text + "</span>\n                    </button>\n                </div>\n            ");
            this.items.hide();
            this.items.slice(0, 9).show();
        }
        this.items.hide();
        this.items.slice(0, 9).show();
        this.btn = this.element.find('.js-btn');
        this.btn.on('click', this.more.bind(this));
    }
    LoadMoreElements.prototype.more = function () {
        this.items.filter(':hidden').slice(0, 6).show();
        if (this.items.length == this.items.filter(':visible').length) {
            this.btn.hide();
        }
    };
    return LoadMoreElements;
}());
exports.LoadMoreElements = LoadMoreElements;
var loadmore = new LoadMore();
},{}],6:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./menu");
require("./KlantenVertellen");
// import "./fade";
require("./loadMore");
require("./faq");
require("./lightbox");
require("./anchor");
require("./popup");
},{"./KlantenVertellen":1,"./anchor":2,"./faq":3,"./lightbox":4,"./loadMore":5,"./menu":7,"./popup":8}],7:[function(require,module,exports){
var Menu = /** @class */ (function () {
    function Menu() {
        $('.c-nav-toggle').on('click', this.toggle.bind(this));
        $('main').on('click', this.destroy.bind(this));
        $(window).resize(this.destroy.bind(this));
        // $(window).resize(this.height.bind(this));
        // this.height();
        //Scroll function
        // vind positie nav
        // vind positie top scherm
        // als positie top scherm > nav is.
        // nav position fixed geven
        if ($(window).width() >= 769) {
            this.navpos = $('.c-nav').offset().top;
            $(window).on("scroll", this.navpostion.bind(this));
        }
    }
    Menu.prototype.navpostion = function (navpos) {
        var nav = $('.c-nav');
        var scrollTop = $(window).scrollTop();
        if (scrollTop > this.navpos) {
            if (!nav.hasClass("is-sticky")) {
                nav.addClass("is-sticky");
            }
            else {
                return;
            }
        }
        else {
            nav.removeClass("is-sticky");
        }
    };
    Menu.prototype.toggle = function (event) {
        event.preventDefault();
        $('body').toggleClass('is-activeNav');
    };
    Menu.prototype.destroy = function () {
        if ($('.is-activeNav').length) {
            $('body').removeClass('is-activeNav');
        }
    };
    Menu.prototype.height = function () {
        if ($(window).width() >= 600) {
            this.menu = $('.c-nav').innerHeight();
            $('body').css({ "padding-top": this.menu - 0 + "px" });
        }
        else if ($(window).width() <= 600) {
            $('body').css({ "padding-top": "0px" });
        }
    };
    return Menu;
}());
var menu = new Menu();
},{}],8:[function(require,module,exports){
var Popup = /** @class */ (function () {
    function Popup() {
        this.element = $(".js-popup");
        var cookiename = getCookie("verdelpopup");
        if (cookiename != "closed") {
            if ($(window).width() >= 600) {
                window.setTimeout(function () {
                    $(".js-popup").addClass("js-popup--show");
                }, 5000);
            }
        }
        this.close = this.element.find(".js-close");
        if (!this.element.length)
            return;
        this.close.on('click', function () {
            this.element.removeClass("js-popup--show");
            document.cookie = "verdelpopup=closed; expires=0; path=/; SameSite=None; secure";
        }.bind(this));
    }
    return Popup;
}());
function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1);
        if (c.indexOf(name) != -1)
            return c.substring(name.length, c.length);
    }
    return "";
}
var popup = new Popup();
},{}]},{},[6])

